import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexindex-grid'
import format from '../../helpers/format'
import config from '../../config'
import {
  Link,
} from '../../components'
import Styles from './BenchmarkGridTable.css'


@CSSModules(Styles,{allowMultiple:true})
export default class BenchmarkGridTable extends Component {
  static propTypes = {
    gradeField: PropTypes.string.isRequired,
    gradeName:  PropTypes.string.isRequired
  }

  constructor(props){
    super(props)
    this.state = {}
  }

  sortBenchmarks = (gradeField) => {
    const indxs = {
      'S&P 500': 0,
      'Russell 1000': 1,
      'Russell 2000': 2,
      'Russell 3000': 3,
      'S&P 100': 4,
      'Russell Top 200': 5,
      'MSCI ACWI': 6,
      'MSCI EAFE': 7,
      'MSCI Emerging Markets': 8,
      'MSCI ACWI ex U.S.': 9,
    }
    const sorted = Array.apply(null, Array(10)).map((x, i) => { return null; })
    const benchmarks = [].concat(
      config.coreBenchmarks.concat(config.extendedBenchmarks))

    for (let i = 0; i<benchmarks.length; i++){
      if (indxs.hasOwnProperty(benchmarks[i].index_name)){
        sorted[indxs[benchmarks[i].index_name]] = benchmarks[i]
      }
    }
    return sorted
  }
  //
  render() {
    const sortedBenchmarks = this.sortBenchmarks(this.props.gradeField)
    //
    return <table styleName='index-table'>
      <thead>
        <tr>
          <th>
            Index
          </th>
          <th>
            Rated as
          </th>
          <th>
            {this.props.gradeName.charAt(0).toUpperCase() + this.props.gradeName.slice(1)} grade
          </th>
        </tr>
      </thead>
      <tbody>
        {
          sortedBenchmarks.map((b, i) => {
            const sName = format.sanitize(b.fund_legal_name)
            const sTicker = b.ticker || 'N'
            const url =
              config.routes.fund + '/' +
              sName + '/' +
              sTicker + '/' + config.profilePath + '/' +
              b.fund_id + '/' +
              b.investment_vehicle_id
            const charGrade = b[this.props.gradeField].toString()
            const letterGrade = {
              1: 'A',
              2: 'B',
              3: 'C',
              4: 'D',
              5: 'F',
            }[b[this.props.gradeField]] || 'N/A'
            //
            return <tr key={i}>
              <td styleName='index-title'>
                <Link
                  to={url}
                  styleName='index-link'
                  title={b.fund_legal_name + ' | ' + config.app.title}
                >
                  { b.index_name }
                </Link>
              </td>
              <td styleName='index-subtitle'>
                <Link
                  to={url}
                  styleName='index-link'
                  title={b.fund_legal_name + ' | ' + config.app.title}
                >
                  { b.ticker }
                </Link>
              </td>
              <td styleName={'index-grade-wrap index-grade-wrap-'+b[this.props.gradeField]}>
                <Link
                  to={url}
                  styleName='index-link'
                  title={b.fund_legal_name + ' | ' + config.app.title}
                >
                  {letterGrade}
                </Link>
              </td>
            </tr>
          })
        }
      </tbody>
    </table>
  }
}
